<template>
  <div class="home">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="mySvg"
      width="100vw"
      height="100vh"
      @mouseleave="
        this.svg.removeEventListener('mouseup', this.mouseup);
        this.mouseDown = false;
      "
    >
      <foreignObject
        v-for="item in postList"
        :key="item"
        :x="item.centerX - item.width / 2"
        :y="item.centerY - item.height / 2"
        :width="item.width * 1.1"
        :height="item.height * 1.1"
        class="
          transition
          ease-in-out
          hover:-translate-y-5
          duration-300
          animate-in
          fade-in
        "
      >
        <component
          :is="cardTypes[item.postStyle]"
          :postText="item.postText"
          :anonymous="item.anonymous"
          :username="item.userName"
          :atCreationPage="false"
          :age="item.ageAtPost"
          :likeCount="item.likeCount"
          :dislikeCount="item.dislikeCount"
          :postDate="fixDateToString(item.postDate)"
          :blurPost="item.blur"
          :likePost="false"
          :dislikePost="false"
          :postID="item.postID"
          class="select-none fixed transition"
          @mouseover="onPost = true"
          @mouseleave="onPost = false"
          @changeLikePost="
            $event ? (item.likeCount += 1) : (item.likeCount -= 1)
          "
          @changeDislikePost="
            $event ? (item.dislikeCount += 1) : (item.dislikeCount -= 1)
          "
          :id="'post_' + item.postID"
        />
      </foreignObject>
    </svg>
  </div>
</template>

<script>
// @ is an alias to /src
import { SVGMixin } from "../mixins/SVGMixin.js";
import CardStyle0 from "../components/CardStyle0.vue";
import CardStyle1 from "../components/CardStyle1.vue";
import CardStyle2 from "../components/CardStyle2.vue";
import CardStyle3 from "../components/CardStyle3.vue";
import CardStyle4 from "../components/CardStyle4.vue";
import store from "../store";
import axios from "axios";
export default {
  name: "HomeView",
  mixins: [SVGMixin],
  components: {
    CardStyle0,
    CardStyle1,
    CardStyle2,
    CardStyle3,
    CardStyle4,
  },
  data() {
    return {
      cardTypes: [
        "CardStyle0",
        "CardStyle1",
        "CardStyle2",
        "CardStyle3",
        "CardStyle4",
      ],

      // for svg stuffs
      mouseStartPosition: { x: 0, y: 0 }, // for resize etc
      mousePosition: { x: 0, y: 0 },
      viewboxStartPosition: { x: 0, y: 0 },
      viewboxPosition: { x: 0, y: 0 },
      viewboxSize: { x: 0, y: 0 },
      viewboxScale: 1.0,
      onPost: false, // if we can zoom or not
    };
  },
  computed: {
    postList() {
      return store.getters.postList;
    },
    seenPostIDs() {
      return store.getters.seenPostIDs;
    },
    seenGrids() {
      return store.getters.seenGrids;
    },
    gridSize() {
      return store.getters.gridSize;
    },
    moveToCenter() {
      return store.getters.moveToCenter;
    },
    centerX() {
      return store.getters.centerX;
    },
    centerY() {
      return store.getters.centerY;
    },
  },
  methods: {
    async setviewbox() {
      var vp = { x: 0, y: 0 };
      var vs = { x: 0, y: 0 };

      vp.x = this.viewboxPosition.x;
      vp.y = this.viewboxPosition.y;

      vs.x = this.viewboxSize.x * this.viewboxScale;
      vs.y = this.viewboxSize.y * this.viewboxScale;

      this.svg.setAttribute(
        "viewBox",
        vp.x + " " + vp.y + " " + vs.x + " " + vs.y
      );
      // router.push({ path: "", query: { x: vp.x + vs.x / 2, y: vp.y + vs.y / 2 } })
      const grids = this.findGridIndices(vp.x, vp.y, vs.x, vs.y);
      if (grids.length != 0) {
        store.dispatch("getAllPostsInGrids", grids);
      }
    },
    mousedown(e) {
      this.mouseStartPosition.x = e.pageX;
      this.mouseStartPosition.y = e.pageY;

      this.viewboxStartPosition.x = this.viewboxPosition.x;
      this.viewboxStartPosition.y = this.viewboxPosition.y;
      this.mouseDown = true;
      this.svg.addEventListener("mouseup", this.mouseup);
    },
    mouseup() {
      this.mouseDown = false;
      this.svg.removeEventListener("mouseup", this.mouseup);
    },
    mousemove(e) {
      // when we move cursor
      // we want either to move the circle
      // or move the canvas
      this.mousePosition.x = e.offsetX;
      this.mousePosition.y = e.offsetY;
      if (this.mouseDown) {
        this.viewboxPosition.x =
          this.viewboxStartPosition.x +
          (this.mouseStartPosition.x - e.pageX) * this.viewboxScale;
        this.viewboxPosition.y =
          this.viewboxStartPosition.y +
          (this.mouseStartPosition.y - e.pageY) * this.viewboxScale;
        this.setviewbox();
      }
    },
    windowResize() {
      // fire whenever window resize, we want to change the viewbox etc
      this.viewboxSize = { x: this.svg.clientWidth, y: this.svg.clientHeight };
      this.setviewbox();
    },
    wheel(e) {
      if (!this.onPost) {
        var scale = e.deltaY < 0 ? 0.985 : 1.015;
        if (
          this.viewboxScale * scale < 10.0 &&
          this.viewboxScale * scale > 0.8
        ) {
          var mpos = {
            x: this.mousePosition.x * this.viewboxScale,
            y: this.mousePosition.y * this.viewboxScale,
          };
          var vpos = { x: this.viewboxPosition.x, y: this.viewboxPosition.y };
          var cpos = { x: mpos.x + vpos.x, y: mpos.y + vpos.y };

          this.viewboxPosition.x =
            (this.viewboxPosition.x - cpos.x) * scale + cpos.x;
          this.viewboxPosition.y =
            (this.viewboxPosition.y - cpos.y) * scale + cpos.y;
          this.viewboxScale *= scale;
          this.setviewbox();
        }
      }
    },
    fixDateToString(txt) {
      let yourDate = new Date(txt);
      const offset = yourDate.getTimezoneOffset();
      yourDate = new Date(yourDate.getTime() - offset * 60 * 1000);
      return yourDate.toISOString().split("T")[0];
    },
    findGridIndices(x_min, y_min, width, height) {
      const x_min_index = Math.floor(x_min / this.gridSize);
      const x_max_index = Math.floor((x_min + width) / this.gridSize);
      const y_min_index = Math.floor(y_min / this.gridSize);
      const y_max_index = Math.floor((y_min + height) / this.gridSize);
      const x_center_index = Math.floor((x_max_index + x_min_index) / 2);
      const y_center_index = Math.floor((y_max_index + y_min_index) / 2);
      const matrix_half_length = Math.ceil(
        Math.max(x_max_index - x_min_index, y_max_index - y_min_index) / 2
      );

      var list_of_grids = [];
      list_of_grids.push({ xIndex: x_center_index, yIndex: x_center_index });
      for (var offset = 1; offset <= matrix_half_length; offset++) {
        const left = x_center_index - offset;
        const top = y_center_index - offset;
        const right = x_center_index + offset;
        const bot = y_center_index + offset;
        list_of_grids.push({ xIndex: right, yIndex: y_center_index });
        list_of_grids.push({ xIndex: left, yIndex: y_center_index });

        list_of_grids.push({ xIndex: x_center_index, yIndex: top });
        list_of_grids.push({ xIndex: x_center_index, yIndex: bot });
        for (var i = 1; i <= offset; i++) {
          list_of_grids.push({ xIndex: right, yIndex: y_center_index - i });
          list_of_grids.push({ xIndex: left, yIndex: y_center_index - i });
          list_of_grids.push({ xIndex: right, yIndex: y_center_index + i });
          list_of_grids.push({ xIndex: left, yIndex: y_center_index + i });

          list_of_grids.push({ xIndex: x_center_index - i, yIndex: top });
          list_of_grids.push({ xIndex: x_center_index - i, yIndex: bot });
          list_of_grids.push({ xIndex: x_center_index + i, yIndex: top });
          list_of_grids.push({ xIndex: x_center_index + i, yIndex: bot });
        }
      }
      return list_of_grids;
    },
    async getGridPostIDs(grids) {
      var postList = [];
      for (const grid of grids) {
        var data = JSON.stringify(grid);

        var config = {
          method: "post",
          url: "http://138.197.71.184:5001/grid",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };
        try {
          let res = await axios(config);
          if (res.status == 200) {
            if (res.data.posts) {
              for (const postID of res.data.posts) {
                if (!this.seenPostIDs.has(postID)) {
                  store.dispatch("addSeenPostIDs", postID);
                  postList.push(postID);
                }
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
      return postList;
    },

    async getPosts(postList) {
      for (const postID of postList) {
        var data = JSON.stringify({
          postID: postID,
        });

        var config = {
          method: "post",
          url: "http://138.197.71.184:5001/viewPost",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };
        try {
          let res = await axios(config);
          if (res.status == 200) {
            store.dispatch("addPost", res.data);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  created() {
    window.addEventListener("resize", this.windowResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.windowResize);
  },
  mounted() {
    this.svg = document.getElementById("mySvg");

    this.viewboxSize.x = this.svg.clientWidth;
    this.viewboxSize.y = this.svg.clientHeight;
    if (!this.moveToCenter) {
      this.viewboxPosition = {
        x: -this.svg.clientWidth / 2,
        y: -this.svg.clientHeight / 2,
      };
    } else {
      this.viewboxPosition = {
        x: this.centerX - this.svg.clientWidth / 2,
        y: this.centerY - this.svg.clientHeight / 2,
      };
      store.dispatch("fufillMoveToCenter");
    }

    this.svg.addEventListener("mousedown", this.mousedown);
    this.svg.addEventListener("mousemove", this.mousemove);
    this.svg.addEventListener("wheel", this.wheel);
    this.setviewbox();
  },
};
</script>

<style scoped>
body {
  overflow-y: hidden;
}
.out-of-page {
  position: absolute;
  left: -5000px;
  top: -5000px;
}
</style>